var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.c_surveyItemComponent,{tag:"component",attrs:{"p_surveyItem":_vm.p_surveyItem,"p_objValues":_vm.p_objValues}})}
var staticRenderFns = []

export { render, staticRenderFns }